import { useEffect, useState } from 'react'
import { OfflinePatient, patientOfflineStore } from '@/core/offline'

export function usePatientsLoader(isOfflineDatabaseReady: boolean) {
  const [loading, setLoading] = useState(true)
  const [patients, setPatients] = useState<OfflinePatient[]>([])

  useEffect(() => {
    if (isOfflineDatabaseReady) {
      loadPatients()
    }
  }, [isOfflineDatabaseReady])

  const loadPatients = async () => {
    try {
      setLoading(true)
      const allPatients = await patientOfflineStore.getAll()
      setPatients(allPatients)
    } catch (error) {
      console.error('Error loading offline patients:', error)
      // TODO: Add error handling UI
    } finally {
      setLoading(false)
    }
  }

  return {
    patients,
    loading,
  }
}
